import * as React from "react";
import {MenuItem, NavDropdown} from "react-bootstrap";
import {defineMessages, InjectedIntlProps, injectIntl} from "react-intl";
import {connect} from "react-redux";
import {LinkContainer} from "react-router-bootstrap";
import {Links} from "./model";
import {oidcProviderInfo} from "../oidc/startOidcProvider";

const HELP_MESSAGES = defineMessages({
    help: {
        id: "studio.navbar.help",
        defaultMessage: "Help",
    },
    userGuide: {
        id: "studio.navbar.help.user-guide",
        defaultMessage: "User Guide",
    },
    support: {
        id: "studio.navbar.help.support",
        defaultMessage: "Support",
    },
    about: {
        id: "studio.navbar.help.about",
        defaultMessage: "About",
    },
    api: {
        id: "studio.navbar.help.api",
        defaultMessage: "API Console",
    },
});

class HelpNavDropdownComponent extends React.Component<InjectedIntlProps, unknown> {
    render() {
        const {intl} = this.props;
        const isOidcEnabled = oidcProviderInfo?.enabled;
        return (
            <NavDropdown className="user-tour-help-page-nav" eventKey={"help"} id="helpDropDown"
                         title={intl.formatMessage(HELP_MESSAGES.help)}>
                <MenuItem onClick={(_event) => window.open(Links.USER_GUIDE, "_blank", "noreferrer")}
                          eventKey={"userGuide"}
                          key={"userGuide"}>
                    {intl.formatMessage(HELP_MESSAGES.userGuide)}
                </MenuItem>
                <MenuItem onClick={(_event) => window.open(Links.SUPPORT, "_blank", "noreferrer")}
                          eventKey={"support"}
                          key={"support"}>
                    {intl.formatMessage(HELP_MESSAGES.support)}
                </MenuItem>
              { !isOidcEnabled &&
                <MenuItem onClick={(_event) => window.open("../api/console", "_blank", "noreferrer")}
                          eventKey={"api"}
                          key={"api"}>
                    {intl.formatMessage(HELP_MESSAGES.api)}
                </MenuItem>}
                <LinkContainer to="/about">
                    <MenuItem eventKey={"about"} key={"about"}>
                        {intl.formatMessage(HELP_MESSAGES.about)}
                    </MenuItem>
                </LinkContainer>
            </NavDropdown>
        );
    }
}

export const HelpNavDropdown = injectIntl<{}>(connect()(HelpNavDropdownComponent));